import { render } from "./DocumentItemWithSlot.vue?vue&type=template&id=7c50fc36&scoped=true&ts=true&lang=pug"
import script from "./DocumentItemWithSlot.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentItemWithSlot.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentItemWithSlot.vue?vue&type=style&index=0&id=7c50fc36&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c50fc36"]])

export default __exports__